import Image from 'global/Image';
import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 11px 16px;
  border-top: 1px solid #DADADA;
`;

export const FooterIcon = styled(Image)`
  max-height: 16px;
  margin-left: 20px;
  cursor: pointer;
`;
